import type { DealType } from './Deal';

export type DealDashboard = {
  dealTypeInfo: {
    restorationCount: number;
    repairCount: number;
    otherCount: number;
  };
  dealStatusInfo: {
    nowAcceptingCount: number;
    inEstimationCount: number;
    sendEstimateCount: number;
    inConstructionCount: number;
    awaitingAcceptanceCount: number;
    finishedCount: number;
  };
  dealApplicationTypeInfo: {
    draftCount: number;
    requestCount: number;
    requestedCount: number;
    waitingCancelCount: number;
    acceptedCancelCount: number;
  };
};

export type CompanyDealDashboard = DealDashboard & {
  dealTodoInfo: {
    dueOverCount: number;
    dueTodayCount: number;
    dueInThreeDaysCount: number;
    incompleteCount: number;
    unassignedCount: number;
  };
};

export type DealDashboardCondition = {
  dealTypes?: DealType[];
};

// 案件タイプのクエリパラメータを生成する
const addDealTypeParams = (
  params: URLSearchParams,
  dealTypes: DealType[]
): void => {
  if (dealTypes.length !== ['restoration', 'repair', 'other'].length) {
    dealTypes.forEach((type) => params.append('deal_types[]', type));
  }
};

// 案件ステータスと案件タイプでフィルタされたクエリパラメータを生成する
export const dealStatusQueryParam = (
  statusIds: string[],
  dealTypes: DealType[]
): string => {
  const params = new URLSearchParams();
  statusIds.forEach((id) => params.append('status_id[]', id));
  addDealTypeParams(params, dealTypes);
  return params.toString();
};

// 案件の申請状況と案件タイプでフィルタされたクエリパラメータを生成する
export const dealApplicationStatusQueryParam = (
  applicationType:
    | 'requestEstimation'
    | 'requestEstimationByCompany'
    | 'requestEstimationByVendor'
    | 'draftEstimationByCompany'
    | 'draftEstimation'
    | 'cancel',
  dealTypes: DealType[]
): string => {
  const params = new URLSearchParams();
  params.append('application_types[]', applicationType);
  addDealTypeParams(params, dealTypes);
  return params.toString();
};
